import { Button } from './Button';

export function EmptyState({ title, message, actionLabel, onAction, to, icon: Icon }) {
  return (
    <div className="empty-state">
      {Icon ? <div className="empty-icon"><Icon size={28} /></div> : null}
      <h3>{title}</h3>
      <p>{message}</p>
      {actionLabel ? <Button to={to} onClick={onAction} variant="secondary">{actionLabel}</Button> : null}
    </div>
  );
}
